import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { closeIcon } from "assets/icons";
import { logo } from "assets/logos";
import { GLOBALS } from "config/GLOBALS";
import TabletContext from "context/TabletContext";
import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import BurgerMenu from "../BurgerMenu";
import ProfileButton from "../ProfileButton";
import styles from "./styles.module.css";

export const Header = () => {
  const isTablet = useContext(TabletContext);
  const [isMobileMenuOpened, setIsMobileMenuOpened] = useState(false);

  const menuItems = [
    { name: "Сотрудники", route: "/" },
    { name: "Оборудование", route: "/equipment" },
    { name: "Тех. Инструкции", route: "/instructions" },
    { name: "Задания", route: "/tasks" },
    { name: "Архив", route: "/archive" },
  ];

  const renderHeaderButtons = () => {
    return menuItems?.map((item) => {
      return (
        <NavLink
          key={item.name}
          exact
          to={item.route}
          activeStyle={{
            borderBottom: `4px solid ${GLOBALS.COLORS.PRIMARY_COLOR}`,
          }}
          activeClassName={styles.headerItemActive}
          className={styles.headerItem}
        >
          {item.name}
        </NavLink>
      );
    });
  };

  const handleMenuPress = () => {
    setIsMobileMenuOpened(!isMobileMenuOpened);
  };

  return (
    <div className={styles.container}>
      {isTablet && (
        <BurgerMenu
          renderHeaderButtons={renderHeaderButtons}
          isMobileMenuOpened={isMobileMenuOpened}
        />
      )}

      <div className={styles.headerContainer}>
        {isTablet &&
          (isMobileMenuOpened ? (
            <div onClick={handleMenuPress}>
              <img
                className={styles.burgerMenuIcon}
                src={closeIcon}
                alt="Menu"
              />
            </div>
          ) : (
            <FontAwesomeIcon
              icon={faBars}
              onClick={handleMenuPress}
              className={styles.burgerMenuIcon}
            />
          ))}

        <img src={logo} className={styles.logo} alt="" />

        <div className={styles.headerWrapper}>
          {!isTablet && (
            <div className={styles.headerItemsWrapper}>
              {renderHeaderButtons()}
            </div>
          )}
          <div className={styles.headerIconsContainer}>
            <ProfileButton />
          </div>
        </div>
      </div>

      {isMobileMenuOpened && isTablet && (
        <div className={styles.shadow} onClick={handleMenuPress} />
      )}
    </div>
  );
};
